/* eslint-disable */

/**
 * Do not edit this file directly! It's generated by the `$ pnpm generate-icons-source` script.
 */

export const ICON_NAME_ACCOUNT = 'account';
export const ICON_NAME_ANDROID = 'android';
export const ICON_NAME_ANNOUNCEMENT = 'announcement';
export const ICON_NAME_APPLE = 'apple';
export const ICON_NAME_ARROW_DOWN = 'arrow-down';
export const ICON_NAME_ARROW_LEFT = 'arrow-left';
export const ICON_NAME_ARROW_RIGHT = 'arrow-right';
export const ICON_NAME_ARROW_UP = 'arrow-up';
export const ICON_NAME_ATTENTION = 'attention';
export const ICON_NAME_BAN = 'ban';
export const ICON_NAME_BELL = 'bell';
export const ICON_NAME_BET = 'bet';
export const ICON_NAME_BET_FILLED = 'bet-filled';
export const ICON_NAME_BOARD_GAME = 'board-game';
export const ICON_NAME_BRIEFCASE = 'briefcase';
export const ICON_NAME_BROADCAST = 'broadcast';
export const ICON_NAME_CARDS = 'cards';
export const ICON_NAME_CASHBACK = 'cashback';
export const ICON_NAME_CHECK = 'check';
export const ICON_NAME_CHECK_FILLED = 'check-filled';
export const ICON_NAME_CHEVRON_DOWN = 'chevron-down';
export const ICON_NAME_CHEVRON_DOWN_THIN = 'chevron-down-thin';
export const ICON_NAME_CHEVRON_LEFT = 'chevron-left';
export const ICON_NAME_CHEVRON_RIGHT = 'chevron-right';
export const ICON_NAME_CHEVRON_UP = 'chevron-up';
export const ICON_NAME_CLOSE = 'close';
export const ICON_NAME_CLOSE_M = 'close-m';
export const ICON_NAME_CLOSE_TINY = 'close-tiny';
export const ICON_NAME_CLOSE_TOOLTIP = 'close-tooltip';
export const ICON_NAME_COGWHEEL = 'cogwheel';
export const ICON_NAME_COINKEEPER = 'coinkeeper';
export const ICON_NAME_COMMENT = 'comment';
export const ICON_NAME_COMMENT_ALT = 'comment-alt';
export const ICON_NAME_COPY = 'copy';
export const ICON_NAME_CORNER = 'corner';
export const ICON_NAME_COUPON = 'coupon';
export const ICON_NAME_CREDIT_CARD = 'credit-card';
export const ICON_NAME_CROSS = 'cross';
export const ICON_NAME_CURRENCY_KGS = 'currency-kgs';
export const ICON_NAME_CURRENCY_KZT = 'currency-kzt';
export const ICON_NAME_CURRENCY_RUB = 'currency-rub';
export const ICON_NAME_DATETIME = 'datetime';
export const ICON_NAME_ERROR = 'error';
export const ICON_NAME_ERROR_FILLED = 'error-filled';
export const ICON_NAME_EXCLAMATION = 'exclamation';
export const ICON_NAME_EXPAND_V = 'expand-v';
export const ICON_NAME_EYE = 'eye';
export const ICON_NAME_EYE_SLASH = 'eye-slash';
export const ICON_NAME_FACE_SAD = 'face-sad';
export const ICON_NAME_FAVORITE = 'favorite';
export const ICON_NAME_FAVORITE_ACTIVE = 'favorite-active';
export const ICON_NAME_FEEDBACK = 'feedback';
export const ICON_NAME_FILTER = 'filter';
export const ICON_NAME_FINAL_SCORE = 'final-score';
export const ICON_NAME_FIRE = 'fire';
export const ICON_NAME_FLAG = 'flag';
export const ICON_NAME_FLAG_EN = 'flag-en';
export const ICON_NAME_FLAG_KK = 'flag-kk';
export const ICON_NAME_FLAG_KY = 'flag-ky';
export const ICON_NAME_FLAG_RU = 'flag-ru';
export const ICON_NAME_FLAG_TG = 'flag-tg';
export const ICON_NAME_FLAG_UZ = 'flag-uz';
export const ICON_NAME_FREEBET = 'freebet';
export const ICON_NAME_GIFT = 'gift';
export const ICON_NAME_GRAPHIC_BROADCAST = 'graphic-broadcast';
export const ICON_NAME_HEADSET = 'headset';
export const ICON_NAME_HELP = 'help';
export const ICON_NAME_HIDE_DETAILS = 'hide-details';
export const ICON_NAME_HOCKEY_HELMET = 'hockey-helmet';
export const ICON_NAME_LIVE = 'live';
export const ICON_NAME_LOCK = 'lock';
export const ICON_NAME_LOGOUT = 'logout';
export const ICON_NAME_LOSE = 'lose';
export const ICON_NAME_MAIL = 'mail';
export const ICON_NAME_MATCH_CALCULATION = 'match-calculation';
export const ICON_NAME_MATCH_COMMENT = 'match-comment';
export const ICON_NAME_MEGAPHONE = 'megaphone';
export const ICON_NAME_MICRO_CHEVRON_DOWN = 'micro-chevron-down';
export const ICON_NAME_MICRO_CHEVRON_RIGHT = 'micro-chevron-right';
export const ICON_NAME_MOON = 'moon';
export const ICON_NAME_MORE = 'more';
export const ICON_NAME_PAST = 'past';
export const ICON_NAME_PHONE = 'phone';
export const ICON_NAME_PICTURE_IN_PICTURE_CLOSE = 'picture-in-picture-close';
export const ICON_NAME_PICTURE_IN_PICTURE_OPEN = 'picture-in-picture-open';
export const ICON_NAME_PLAY = 'play';
export const ICON_NAME_PREFERENCES = 'preferences';
export const ICON_NAME_PRICE = 'price';
export const ICON_NAME_PRICE_DOWN = 'price-down';
export const ICON_NAME_PRICE_FILLED = 'price-filled';
export const ICON_NAME_PRICE_UP = 'price-up';
export const ICON_NAME_PRIVATE_OFFICE = 'private-office';
export const ICON_NAME_PROFILE = 'profile';
export const ICON_NAME_RELOAD = 'reload';
export const ICON_NAME_RETURN = 'return';
export const ICON_NAME_RETURN_FILLED = 'return-filled';
export const ICON_NAME_SEARCH = 'search';
export const ICON_NAME_SETTINGS = 'settings';
export const ICON_NAME_SETTINGS_GEAR = 'settings-gear';
export const ICON_NAME_SHOW_DETAILS = 'show-details';
export const ICON_NAME_SOUND_OFF = 'sound-off';
export const ICON_NAME_SOUND_ON = 'sound-on';
export const ICON_NAME_SPORT_AMERICAN_FOOTBALL = 'sport-american-football';
export const ICON_NAME_SPORT_AUTO_RACING = 'sport-auto-racing';
export const ICON_NAME_SPORT_BADMINTON = 'sport-badminton';
export const ICON_NAME_SPORT_BASEBALL = 'sport-baseball';
export const ICON_NAME_SPORT_BASKETBALL = 'sport-basketball';
export const ICON_NAME_SPORT_BEACH_VOLLEYBALL = 'sport-beach-volleyball';
export const ICON_NAME_SPORT_BILLIARD = 'sport-billiard';
export const ICON_NAME_SPORT_BOXING_AND_MMA = 'sport-boxing-and-mma';
export const ICON_NAME_SPORT_CHESS = 'sport-chess';
export const ICON_NAME_SPORT_CS_GO = 'sport-cs-go';
export const ICON_NAME_SPORT_DEFAULT = 'sport-default';
export const ICON_NAME_SPORT_DOTA = 'sport-dota';
export const ICON_NAME_SPORT_E_SPORT = 'sport-e-sport';
export const ICON_NAME_SPORT_FIELD_HOCKEY = 'sport-field-hockey';
export const ICON_NAME_SPORT_FUTSAL = 'sport-futsal';
export const ICON_NAME_SPORT_HANDBALL = 'sport-handball';
export const ICON_NAME_SPORT_HOCKEY_WITH_BALL = 'sport-hockey-with-ball';
export const ICON_NAME_SPORT_ICE_HOCKEY = 'sport-ice-hockey';
export const ICON_NAME_SPORT_LOTTERIES = 'sport-lotteries';
export const ICON_NAME_SPORT_OTHER = 'sport-other';
export const ICON_NAME_SPORT_RUGBY = 'sport-rugby';
export const ICON_NAME_SPORT_SOCCER = 'sport-soccer';
export const ICON_NAME_SPORT_TABLE_TENNIS = 'sport-table-tennis';
export const ICON_NAME_SPORT_TENNIS = 'sport-tennis';
export const ICON_NAME_SPORT_VOLLEYBALL = 'sport-volleyball';
export const ICON_NAME_SPORT_WATER_POLO = 'sport-water-polo';
export const ICON_NAME_STAR = 'star';
export const ICON_NAME_STATISTICS = 'statistics';
export const ICON_NAME_STREAM = 'stream';
export const ICON_NAME_SUCCESS = 'success';
export const ICON_NAME_SUCCESS_FILLED = 'success-filled';
export const ICON_NAME_SUCCESS_MARK = 'success-mark';
export const ICON_NAME_SUPPORT = 'support';
export const ICON_NAME_SUPPORT_FRESH_CHAT = 'support-fresh-chat';
export const ICON_NAME_TIME = 'time';
export const ICON_NAME_TRASH = 'trash';
export const ICON_NAME_TRASH_ALT = 'trash-alt';
export const ICON_NAME_VEHICLE = 'vehicle';
export const ICON_NAME_VOLUME_OFF = 'volume-off';
export const ICON_NAME_VOLUME_ON = 'volume-on';
export const ICON_NAME_WALLET_TOP_UP = 'wallet-top-up';
export const ICON_NAME_WARNING = 'warning';
export const ICON_NAME_WARNING_COLORED = 'warning-colored';
export const ICON_NAME_WI_FI = 'wi-fi';
export const ICON_NAME_WIN = 'win';
export const ICON_NAME_WIN_FILLED = 'win-filled';
export const ICON_NAME_WITHDRAW = 'withdraw';
